import { z } from 'zod';

import { userStatusValues, type UserDto, type UserStatus } from './user.dto.js';

export const UserStatusSchema: z.ZodType<UserStatus> = z.enum(userStatusValues);

export const UserSchema: z.ZodType<UserDto> = z.object({
  id: z.uuid(),
  email: z.string().trim().pipe(z.email()),
  status: UserStatusSchema,
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
